"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDisciplinesProperty = exports.disciplinesPropertyDefinition = void 0;
exports.disciplinesPropertyDefinition = {
    view: {
        label: 'Disciplines',
        style: 'tag',
        hint: 'Collections for a skill, sport, or interest. Tag on the most granular level, e.g. MTB Cross-Country.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['discipline'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'disciplines',
};
const isDisciplinesProperty = (prop) => {
    return prop.name === exports.disciplinesPropertyDefinition.name;
};
exports.isDisciplinesProperty = isDisciplinesProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlzY2lwbGluZXMucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9kaXNjaXBsaW5lcy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDZCQUE2QixHQUFHO0lBQzNDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxhQUFhO1FBQ3BCLEtBQUssRUFBRSxLQUFLO1FBQ1osSUFBSSxFQUFFLHNHQUFzRztLQUM3RztJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsWUFBWSxDQUFDO1NBQ3pCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGFBQWE7Q0FDWSxDQUFBO0FBSTFCLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxJQUFrQixFQUErQixFQUFFO0lBQ3ZGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxxQ0FBNkIsQ0FBQyxJQUFJLENBQUE7QUFDekQsQ0FBQyxDQUFBO0FBRlksUUFBQSxxQkFBcUIseUJBRWpDIn0=